import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

const SpeakerIcon: React.FC<IconProps> = (props) => (
  <svg
    role="img"
    aria-label="Speaker Icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <g transform="translate(2, 0)">
      <path d="M11 5L6 9H3v6h3l5 4V5z" />
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
      <path d="M18.07 6.93a8 8 0 0 1 0 10.14" />
    </g>
  </svg>
);

export default SpeakerIcon;
